import * as fetchUserProductMemberships from 'store/actions/users/product-memberships/fetchUserProductMemberships';
import * as createUserProductMembership from 'store/actions/users/product-memberships/createUserProductMembership';
import * as updateUserProductMembership from 'store/actions/users/product-memberships/updateUserProductMembership';
import * as deleteUserProductMembership from 'store/actions/users/product-memberships/deleteUserProductMembership';
import * as fetchUserProductMembershipPool from 'store/actions/users/product-membership-pool/fetchUserProductMembershipPool';
import * as createUserProductMembershipPool from 'store/actions/users/product-membership-pool/createUserProductMembershipPool';
import * as deleteUserProductMembershipPool from 'store/actions/users/product-membership-pool/deleteUserProductMembershipPool';
import * as updateUserProductMembershipPool from 'store/actions/users/product-membership-pool/updateUserProductMembershipPool';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* fetchUserProductMembershipsAsync({ payload }) {
    const {
        onFailure,
        onSuccess,
        params,
    } = payload;

    try {
        const response = yield apiClient.read(`${ config.getApiBaseUrl() }/user-product-memberships`, params);

        if (onSuccess) {
            yield onSuccess(response);
        }

        yield put(fetchUserProductMemberships.fetchUserProductMembershipsSuccess(response));
    } catch (error) {
        if (onFailure) {
            yield onFailure(error);
        }

        yield put(fetchUserProductMemberships.fetchUserProductMembershipsFailure(error));
    }
}

function* fetchUserProductMembershipAsync({ payload }) {
    const {
        id,
    } = payload;

    try {
        const response = yield apiClient.read(`${ config.getApiBaseUrl() }/user-product-memberships/${ id }`);

        yield put(fetchUserProductMemberships.fetchUserProductMembershipSuccess(response));
    } catch (error) {
        yield put(fetchUserProductMemberships.fetchUserProductMembershipFailure(error));
    }
}

function* createUserProductMembershipAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const response = yield apiClient.create(`${ config.getApiBaseUrl() }/user-product-memberships`, values);

        yield put(createUserProductMembership.createUserProductMembershipSuccess(response));

        yield put(showNotification('notifications.user_product_membership.create.success', 'success'));

        yield onSuccess();
    } catch (error) {
        yield put(createUserProductMembership.createUserProductMembershipFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* updateUserProductMembershipAsync({ payload }) {
    const {
        onError,
        onSuccess,
        id,
        values,
    } = payload;

    try {
        const response = yield apiClient.patch(`${ config.getApiBaseUrl() }/user-product-memberships/${ id }`, values);

        yield put(updateUserProductMembership.updateUserProductMembershipSuccess(response));

        yield put(showNotification('notifications.user_product_membership.update.success', 'success'));

        yield onSuccess();
    } catch (error) {
        yield put(updateUserProductMembership.updateUserProductMembershipFailure(error));

        yield onError(error);
    }
}

function* deleteUserProductMembershipAsync({ payload }) {
    const {
        id,
    } = payload;

    try {
        yield apiClient.delete(`${ config.getApiBaseUrl() }/user-product-memberships/${ id }`);

        yield put(deleteUserProductMembership.deleteUserProductMembershipSuccess(id));

        yield put(showNotification('notifications.user_product_membership.delete.success', 'success'));
    } catch (error) {
        yield put(deleteUserProductMembership.deleteUserProductMembershipFailure(error));
    }
}

// User Product Membership Pool
function* fetchUserProductMembershipPoolsAsync({ payload }) {
    const {
        params,
    } = payload;

    try {
        const response = yield apiClient.read(`${ config.getApiBaseUrl() }/user-product-membership-pools`, params);

        yield put(fetchUserProductMembershipPool.fetchUserProductMembershipPoolsSuccess(response));
    } catch (error) {
        yield put(fetchUserProductMembershipPool.fetchUserProductMembershipPoolsFailure(error));
    }
}

function* fetchUserProductMembershipPoolAsync({ payload }) {
    const {
        id,
        params,
    } = payload;

    try {
        const response = yield apiClient.read(`${ config.getApiBaseUrl() }/user-product-membership-pools/${ id }`, params);

        yield put(fetchUserProductMembershipPool.fetchUserProductMembershipPoolSuccess(response));
    } catch (error) {
        yield put(fetchUserProductMembershipPool.fetchUserProductMembershipPoolFailure(error));
    }
}

function* createUserProductMembershipPoolAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const response = yield apiClient.create(`${ config.getApiBaseUrl() }/user-product-membership-pools`, values);

        yield put(createUserProductMembershipPool.createUserProductMembershipPoolSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(createUserProductMembershipPool.createUserProductMembershipPoolFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* updateUserProductMembershipPoolAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const response = yield apiClient.patch(`${ config.getApiBaseUrl() }/user-product-membership-pools`, values);

        yield put(updateUserProductMembershipPool.updateUserProductMembershipPoolSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(updateUserProductMembershipPool.updateUserProductMembershipPoolFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* deleteUserProductMembershipPoolAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        yield apiClient.delete(`${ config.getApiBaseUrl() }/user-product-membership-pools/${ id }`);

        yield put(deleteUserProductMembershipPool.deleteUserProductMembershipPoolSuccess(id));

        if (onSuccess) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(deleteUserProductMembershipPool.deleteUserProductMembershipPoolFailure(error));

        if (onError) {
            yield onError(error);
        }
    }
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* usersSagas() {
    yield [
        // User product-memberships
        takeEvery(types.FETCH_USER_PRODUCT_MEMBERSHIPS, fetchUserProductMembershipsAsync),
        takeEvery(types.FETCH_USER_PRODUCT_MEMBERSHIP, fetchUserProductMembershipAsync),
        takeEvery(types.CREATE_USER_PRODUCT_MEMBERSHIP, createUserProductMembershipAsync),
        takeEvery(types.UPDATE_USER_PRODUCT_MEMBERSHIP, updateUserProductMembershipAsync),
        takeEvery(types.DELETE_USER_PRODUCT_MEMBERSHIP, deleteUserProductMembershipAsync),

        takeEvery(types.FETCH_USER_PRODUCT_MEMBERSHIPS_FAILURE, failureMessage),
        takeEvery(types.FETCH_USER_PRODUCT_MEMBERSHIP_FAILURE, failureMessage),
        takeEvery(types.CREATE_USER_PRODUCT_MEMBERSHIP_FAILURE, failureMessage),
        takeEvery(types.UPDATE_USER_PRODUCT_MEMBERSHIP_FAILURE, failureMessage),
        takeEvery(types.DELETE_USER_PRODUCT_MEMBERSHIP_FAILURE, failureMessage),

        // User product-membership pool
        takeEvery(types.FETCH_USER_PRODUCT_MEMBERSHIP_POOLS, fetchUserProductMembershipPoolsAsync),
        takeEvery(types.FETCH_USER_PRODUCT_MEMBERSHIP_POOL, fetchUserProductMembershipPoolAsync),
        takeEvery(types.CREATE_USER_PRODUCT_MEMBERSHIP_POOL, createUserProductMembershipPoolAsync),
        takeEvery(types.UPDATE_USER_PRODUCT_MEMBERSHIP_POOL, updateUserProductMembershipPoolAsync),
        takeEvery(types.DELETE_USER_PRODUCT_MEMBERSHIP_POOL, deleteUserProductMembershipPoolAsync),

        takeEvery(types.FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_FAILURE, failureMessage),
        takeEvery(types.FETCH_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE, failureMessage),
        takeEvery(types.CREATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE, failureMessage),
        takeEvery(types.UPDATE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE, failureMessage),
        takeEvery(types.DELETE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/userProductMembershipSagas.js